/*Utilidad que entrega una instancia de axios con el jwt configurado*/
import axios from "axios";

let axiosJWT = axios.create({ timeout: 10000 });

let configurarJWT = function(jwt) {
  axiosJWT.defaults.headers.common["Authorization"] = "Bearer " + jwt;
};
let getAxiosJWT = function() {
  return axiosJWT;
};

let cancelToken = () => axios.CancelToken;
let isCancel = error => axios.isCancel;

export default {
  configurarJWT,
  getAxiosJWT,
  cancelToken,
  isCancel
};



// WEBPACK FOOTER //
// ./src/utils/axiosJWT.js